module.exports = __webpack_public_path__ + "frontend-assets/img/next_button.a65b9ba1.png";